// extracted by mini-css-extract-plugin
export default {"comment-box":"CommentBox_comment-box__C1MUL","comment-box__input-wrapper":"CommentBox_comment-box__input-wrapper__l6NKC"};